import { gql } from "@apollo/client";

export const UPSERT_USER_PROFILE_MUTATION = gql`
  mutation UpsertUserProfile($input: UpdateUserProfileInput!) {
    upsertUserProfile(userProfile: $input) {
      id
      stylingPreference
      termsAcceptedAt
      privacyAcceptedAt
    }
  }
`;

export const UPSERT_STYLE_PREFERENCE_MUTATION = gql`
  mutation UpsertStylePreference($input: UpdateStylePreferenceInput!) {
    upsertStylePreference(stylePreference: $input) {
      id
      colorPalette
      silhouettes
      occasions
      budgetRange
      inspirations
    }
  }
`;

export const SAVE_ONBOARDING_STATE_MUTATION = gql`
  mutation SaveOnboardingState($state: JSON!, $merge: Boolean) {
    saveOnboardingState(state: $state, merge: $merge) {
      id
      onboardingState
    }
  }
`;

export const CREATE_WARDROBE_ITEM_MUTATION = gql`
  mutation CreateWardrobeItem($image: String!) {
    createWardrobeItem(image: $image) {
      success
      errors {
        fullMessages
      }
    }
  }
`;
